(function () {
  'use strict';

  /* @ngdoc object
   * @name accounts
   * @description
   *
   */
  angular
    .module('accounts', [
      'ui.router',
      'core'
    ]);
}());
